import win from '../shared/win';

export const loadAccountManagerReCaptchaScript = (pageName) => {
  // Needed for submitting account deletion/subscription cancelation feedback forms.
  const { FORM_RECAPTCHA_SITE_KEY_V3 } = win;
  const scriptId = 'recaptcha-script';

  const existingScript = document.getElementById(scriptId);

  if (pageName === 'AccountManager') {
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://www.google.com/recaptcha/api.js?render=${FORM_RECAPTCHA_SITE_KEY_V3}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  } else {
    // Remove script when leaving AccountManager
    if (existingScript) {
      existingScript.remove();
    }
  }
};

export const hideAccountManagerReCaptchaBadge = (pageName) => {
  // Hide/remove reCaptcha badge to not interfere with Intercom chat UI.
  const recaptchaBadge = document.querySelector('.grecaptcha-badge');
  
  if (pageName === 'AccountManager') {
    if (!recaptchaBadge) return;
    recaptchaBadge.style.display = 'none';
  } else if (recaptchaBadge) {
    recaptchaBadge.remove();
  }
};